export default "__VITE_ASSET__BM10bTH1__"